const ApiPath = {
  AUTH_USER: '/auth/user/me',
  AUTH_EMAIL: '/auth/email/request-otp',
  AUTH_ZERO_CALLBACK: '/auth/auth0/callback',
  EMAIL_VERIFY: '/auth/email/verify-otp',
  AUTH_TELEGRAM: '/auth/telegram/login',
  INITIAL_REWARDS: '/auth/user/initialRewards',
  ONBOARDING_REWARDS: '/user/bonus-Onboarding',
  EXTENDED_INFO: '/user/extended-info',
  USER_QUARRIES: '/quarry/user-quarries',
  USER: '/user',
  USER_DECORATIONS: '/user/decorations',
  SELECT_USER_DECORATION: '/user/decorations/select',
  BUILD_QUARRY: '/quarry/build/',
  UPGRADE_QUARRY: '/quarry/build/',
  TAP_QUARRY: '/quarry/boost/',
  CLAIM_ALL_QUARRIES: '/quarry/claim/all',
  CLAIM_RESOURCE: '/quarry/claim/',
  GET_USER_TASKS: '/user/tasks',
  CLAIM_TASK: '/user/tasks/claim-reward/',
  REFERRAL_EARNINGS: '/user/referral-earnings',
  AIRDROP: '/user/contract/airdrop',
  INVITED_FRIENDS: '/user/invited-friends',
  WITHDRAW_HOLDED_MONEY: '/user/withdraw-holded-money',
  GET_SOCIAL_TASKS: '/user/tasks/social',
  START_SOCIAL_TASK: '/user/tasks/social/start/',
  VERIFY_SOCIAL_TASK: '/user/tasks/social/verify/',
  REWARD_SOCIAL_TASK: '/user/tasks/social/reward/',
  GET_CONTRACTS: '/user/contract',
  OPEN_CHEST: '/user/contract/chestBox',
  APPLY_CHEST: '/user/contract/chestBox/apply/',
  GET_FACTORIES: '/factory/user-factories',
  BUILD_FACTORY: '/factory/build/',
  CLAIM_ALL_MATERIALS: '/factory/claim/all',
  CLAIM_MATERIAL: '/factory/claim/',
  FACTORY: '/factory',
  BOOST: '/boost',
  BOOST_ADVERTISING: '/boost/advertising',
  BOOST_INSTANT_COMPLETE: '/boost/instant-complete/',
  GET_WORKSHOP: '/workshop/user-workshop',
  BUILD_WORKSHOP: '/workshop/build/',
  WORKSHOP: '/workshop',
  CLAIM_ALL_GOODS: '/workshop/claim/all',
  CLAIM_GOODS: '/workshop/claim/',
  PAYMENT: '/payments',
  LEAGUE_INFO: '/league/info',
  LEAGUE_GET_REWARD: '/league/get-reward/',
  LEAGUE_NEW_STARTED: '/league/new-league-started',
  LEAGUE_BOARD: '/league/leaderboard/global',
  ENERGY_REFILL: '/user/energy-refill',
  VIP_INFO: '/vip/info',
  VIP_ACTIVATE: '/vip/activate',
  DAILY_TGEM_BONUS: '/user/daily-tgem-bonus',
  SHOP_INFO: '/shop/info',
  SHOP_BUY: '/shop/buy',
  SHOP_SHUFFLE: '/shop/shuffle',
  PARTNERS: '/partners',
  GET_REWARDS: '/earn-rewards/rewards',
  GAME_BOARD: '/game/board',
  GAME_PANEL: '/game/panel',
  GAME_ROLL: '/game/roll',
  MINI_GAME_ROLL: '/mini-game/roll',
  MINI_GAME_EXIT: '/mini-game/exit',
  START_CARD_GAME: '/mini-game/start-3x3',
  CARD_GAME_OPEN_CELL: '/mini-game/open-cell/',
  CARD_GAME_SAVE_AFTER_BOMB: '/mini-game/save-after-bomb',
  CARD_GAME_COLLECT: '/mini-game/collect',
  GAME_FREE_DAILY_DICE: '/game/get-free-daily-dice',
  PAYMENTS_BUY_DICE: '/payments/buy-dice',
  GAME_BUY_ENERGY: '/game/buy-energy',
  REFERRAL_PARTNERS: '/user/referral-partners',
  WITHDRAW_REQUEST: '/payments/withdraw-request',
  TON_TRANSACTIONS: '/user/ton-transactions',
  STORAGE_SELL: '/storage/sell',
  STORAGE_SELL_ALL: '/storage/sell/all',
  GET_USER_GROUP: '/group-friends/user-group',
  CREATE_USER_GROUP: '/group-friends/create',
  ACCEPT_INVITE_TO_FRIENDS_GROUP: '/group-friends/accept-request',
  REMOVE_PARTICIPANT_FROM_USER_GROUP: '/group-friends/remove-participant/',
  CHANGE_USERS_GROUP_NAME: '/group-friends/change-groupName',
  LEAVE_FROM_USER_GROUP: '/group-friends/leave-group',
  CLAIM_EARN_REWARDS: '/earn-rewards/rewards/claim',
  PROMO_ACTIVATE: '/promo/activate/',
  THANK_YOU_CLAIM: '/user/thank-you/claim',
  BUY_PAID_LINE: '/earn-rewards/rewards/buy-paid-line',
  GET_LOTTERY_INFO: '/lottery/info',
  APPLY_LOTTERY_REWARD: '/lottery/apply-reward/',
  GET_LOTTERY_HISTORY: '/lottery/history/',
  BINGO_EVENT: '/bingo/event',
  BINGO_SPIN: '/bingo/spin',
  BINGO_SUPER_REWARD: '/bingo/super-reward',
  BINGO_PURCHASE: '/bingo/purchase',
  BINGO_LEADERBOARD: '/bingo/leaderboard',
  BINGO_CLAIM_RATING_PRIZE: '/bingo/claim-rating-prize',
  TON_AUTH_GENERATE_PAYLOAD: '/auth/ton/generate-payload',
  TON_AUTH_LOGIN: '/auth/ton/login',
  SCRATCH_EVENT: '/scratch/event',
  SCRATCH_BUY: '/scratch/buy',
  SCRATCH_REVEAL: '/scratch/reveal',
} as const;

export { ApiPath };
